import AuthMarketingLayout from "../components/auth/AuthMarketingLayout";

const LoginPage = () => <AuthMarketingLayout mode="login" />;

export default LoginPage;
